import type { ProdaExportConfig, CompatExportConfig } from "@/generated";

export type TExportConfig = ProdaExportConfig | CompatExportConfig;

export const exportConfigToQuery = (
    exportConfig: TExportConfig,
    nonOperatingAccountsInCoa: boolean,
) => {
    if (exportConfig.exportFormat === "proda")
        return {
            export_format: "proda" as const,
            include_mappings: exportConfig.includeMappings,
            include_summary: exportConfig.includeSummary,
            include_detailed_summary: exportConfig.includeDetailedSummary,
            include_non_operating: nonOperatingAccountsInCoa
                ? exportConfig.includeNonOperating
                : false,
        };
    if (exportConfig.exportFormat === "compat")
        return {
            export_format: "compat" as const,
            include_non_operating: exportConfig.includeNonOperating,
        };
    throw new Error("Invalid export format");
};
